export function formatMoney(value: number, compact = false) {
  if (compact) {
    if (Math.abs(value) >= 1_000_000_000) return `${trim(value / 1_000_000_000)} tỷ`
    if (Math.abs(value) >= 1_000_000) return `${trim(value / 1_000_000)} triệu`
    if (Math.abs(value) >= 1_000) return `${trim(value / 1_000)} nghìn`
  }
  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(value) + ' ₫'
}

function trim(value: number) {
  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2 }).format(value)
}

export function formatPercent(value: number) {
  return new Intl.NumberFormat('vi-VN', { style: 'percent', maximumFractionDigits: 1 }).format(value)
}

export function formatDate(dateString?: string | null) {
  if (!dateString) return ''
  const d = new Date(dateString)
  if (isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat('vi-VN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(d)
}

export function cn(...names: Array<string | false | null | undefined>) {
  return names.filter(Boolean).join(' ')
}
